import { Permission } from "models/auth"
import { createContext } from "react"
import { BlockType } from "shared/types/science35Types"
import { StudentResponse } from "shared/types/teacherTypes"
import { HomeSchoolBlock } from "shared/types/homeschoolTypes"

export type AuthContextType = {
    loading: boolean
    permissions: (Permission)[],
    isLoggedIn: boolean
    emailVerified: boolean
    isStudent: boolean
    isSSO: boolean
    studentInfo?: StudentResponse
    isAdmin: boolean
    isStaff: boolean
    trackingEnabled: boolean
    hasStemSimsAccess: boolean
    hasCurriculumAccess: boolean
    hasScience21Access: boolean
    homeschoolBlocks: HomeSchoolBlock[]
    scienceBlocks: BlockType[]
    csrfToken: string
    triggerAuthRefresh: any
    impersonationMode: boolean  
}

export const AuthContext = createContext<AuthContextType>(({
    loading: true,
    isLoggedIn: false,
    emailVerified: false,
    isStudent: false,
    isSSO: false,
    studentInfo: null,
    isAdmin: false,
    isStaff: false,
    trackingEnabled: false,
    csrfToken: "",
    permissions: [],
    hasStemSimsAccess: false,
    hasCurriculumAccess: false,
    hasScience21Access: false,
    homeschoolBlocks: [],
    scienceBlocks: [],
    triggerAuthRefresh: null,
    impersonationMode: false,
}))

